import {
  RolodexEntryJson,
  RolodexEntryType,
} from 'types/rolodex/rolodexEntries'
import { parseArray, parseNumber, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

/**
 * A high-level system grouping for related units/components at a site.
 */
export class GeckoSystem extends GeckoEntryBase<
  {
    name: string
    description?: string
    type: string
    owner: string
    criticality: number
    groupings: string[]
  },
  {
    organization: string
    site: string
    [RolodexEntryType.PROCESS_FLOW_DIAGRAM]?: string
  }
> {
  private constructor(json: RolodexEntryJson) {
    // Coerce unknown data into the expected shape using parse helpers
    const groupings = parseArray<string>(json.data.groupings) ?? []

    super(
      json,
      {
        name: parseString(json.data.name) ?? '',
        description: parseString(json.data.description),
        type: parseString(json.data.type) ?? '',
        owner: parseString(json.data.owner) ?? '',
        criticality: parseNumber(json.data.criticality) ?? 0,
        groupings,
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
        [RolodexEntryType.PROCESS_FLOW_DIAGRAM]:
          parseString(json.tags[RolodexEntryType.PROCESS_FLOW_DIAGRAM]) ?? '',
      },
      {}
    )

    // Ensure the type is explicitly set to system (in case raw json has mismatch)
    // This does not mutate raw; it ensures consumers see correct type at runtime
    ;(this as { type: RolodexEntryType }).type = RolodexEntryType.SYSTEM
  }

  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoSystem(json)
  }
}
